import { INavData } from '@coreui/angular';
export const navItems = () => {
  const navItems: INavData[] = [
    {
      name: 'Dashboard',
      url: '/',
      icon: 'nav-icon fa fa-dashboard',
      children: [
        {
          name: 'Services',
          url: '/dashboard/order-dashboard',
          icon: 'nav-icon fa fa-first-order',
        },
        {
          name: 'Doctor',
          url: '/health/doctor-statistics',
          icon: 'nav-icon fa fa-medkit'
        },
        {
          name: 'Partner Nurse',
          url: '/health/nurse-statistics',
          icon: 'nav-icon fa fa-user-md'
        },
        {
          name: 'Partner Ambulance',
          url: '/health/ambulance-statistics',
          icon: 'nav-icon fa fa-ambulance'
        },
        {
          name: 'DriverDeliveryPartner',
          url: '/dashboard/partner-dashboard',
          icon: 'nav-icon fa fa-user-circle-o'
        },
        {
          name: 'User',
          url: '/dashboard/user-dashboard',
          icon: 'nav-icon fa fa-user'
        },
        {
          name: 'Employee',
          url: '/dashboard/employee-dashboard',
          icon: 'nav-icon fa fa-user'
        },
      ]
    },
    {
      name: 'MasterConfig',
      url: '/master',
      icon: 'nav-icon fa fa-dashboard',
      children: [
        {
          name: 'Coupon',
          url: '/coupon/coupons',
          icon: 'nav-icon fa fa-tag fa-lg'
        },
        {
          name: 'Food-Offer',
          url: '/coupon/food-offers',
          icon: 'nav-icon fa fa-tag fa-lg'
        },
        {
          name: 'Notification Template',
          url: '/notification',
          icon: 'nav-icon fa fa-bell'
        },
        {
          name: 'Training Lesson',
          url: '/training',
          icon: 'nav-icon fa fa-bell'
        },
        {
          name: 'Exams',
          url: '/exams',
          icon: 'nav-icon fa fa-bell'
        },
        {
          name: 'BannerManagement',
          url: '/banner-management/banner-images',
          icon: 'nav-icon fa fa-picture-o'
        },
        {
          name: 'ReferralConfiguration',
          url: '/referral-configuration',
          icon: 'nav-icon fa fa-cog'
        }
      ]
    },
    {
      name: 'Configuration',
      url: '/configuration',
      icon: 'nav-icon fa fa-cog',
      children: [
        {
          name: 'Shipment-Size-Config',
          url: '/configuration/shipment-item-config',
          icon: 'nav-icon fa fa-shirtsinbulk'
        },
        // {
        //   name: (languageCode === LanguageCodeEnum.US_English) ? 'Shipping-Charge-Config ' : 'Configuración de carga de envío',
        //   url: '/configuration/shipping-charge-config',
        //   icon: 'nav-icon fa fa-shirtsinbulk'
        // },
        {
          name: 'Shipment-Carrier',
          url: '/configuration/shipment-carrier',
          icon: 'nav-icon fa fa-ship'
        },
        {
          name: 'Bank-Configuration',
          url: '/configuration/bank-configuration',
          icon: 'nav-icon fa fa-university'
        },
        {
          name: 'Config-Settings',
          url: '/configuration/config-settings',
          icon: 'nav-icon fa fa-caret-square-o-up'
        },
        {
          name: 'Cancellation-Charge',
          url: '/configuration/cancellation-charge',
          icon: 'nav-icon fa fa-ban'
        },
        {
          name: 'Vehicle-Category',
          url: '/configuration/vehicle-category',
          icon: 'nav-icon fa fa-taxi'
        },
        {
          name: 'Food-Category',
          url: '/configuration/food-category',
          icon: 'nav-icon fa fa-birthday-cake'
        },
        {
          name: 'App-Versions',
          url: '/configuration/app-versions',
          icon: 'nav-icon fa fa-mobile'
        }
      ]
    },
    {
      name: 'Language Configuration',
      url: '/language',
      icon: 'nav-icon fa fa-sign-language',
      children: [
        {
          name: 'System Variable Settings',
          url: '/language/system-settings',
          icon: 'nav-icon fa fa-american-sign-language-interpreting'
        },
        {
          name: 'UI Label Settings',
          url: '/language/language-settings',
          icon: 'nav-icon fa fa-shirtsinbulk'
        },
      ]
    },
    {
      name: 'Promotion',
      url: '/promotion',
      icon: 'nav-icon fa fa-bullhorn',
      children: [
        {
          name: 'SMSNotification',
          url: '/promotion/sms-notification',
          icon: 'nav-icon fa fa-paper-plane'
        },
        {
          name: 'PushNotification',
          url: '/promotion/push-notification',
          icon: 'nav-icon fa fa-paper-plane'
        },
        {
          name: 'EmailNotification',
          url: '/promotion/email-notification',
          icon: 'nav-icon fa fa-paper-plane'
        },
      ]
    },
    {
      name: 'Productivity',
      url: '/productivity',
      icon: 'nav-icon fa fa-industry',
    },
    {
      name: 'OnlinePartners',
      url: '/online-partners',
      icon: 'nav-icon fa fa-map-marker'
    },
    {
      name: 'VOOYCommunity',
      url: '/user',
      icon: 'nav-icon fa fa-users',
      children: [
        {
          name: 'VOOY Doctors',
          url: '/health/doctor-list',
          icon: 'nav-icon fa fa-medkit'
        },
        {
          name: 'VOOY Nurses',
          url: '/health/nurses-list',
          icon: 'nav-icon fa fa-user-md'
        },
        {
          name: 'VOOY Ambulances',
          url: '/health/ambulance-list',
          icon: 'nav-icon fa fa-ambulance'
        },
        {
          name: 'Employees',
          url: '/user/vooy-employees',
          icon: 'nav-icon fa fa-user'
        },
        {
          name: 'VOOY Users',
          url: '/user/vooy-users',
          icon: 'nav-icon fa fa-university'
        },
        {
          name: 'VOOYDriverPartner',
          url: '/user/vooy-partners',
          icon: 'nav-icon fa fa-money'
        },

        {
          name: 'VOOYRestaurants',
          url: '/user/seller-list',
          icon: 'nav-icon fa fa-cutlery'
        },
      ]
    },
    {
      name: 'DeletedProfiles',
      url: '/deleted-users',
      icon: 'nav-icon fa fa-archive',
      children: [
        {
          name: 'VOOY Doctors',
          url: '/deleted-users/doctor-list',
          icon: 'nav-icon fa fa-medkit'
        },
        {
          name: 'VOOY Nurses',
          url: '/deleted-users/nurse-list',
          icon: 'nav-icon fa fa-user-md'
        },
        {
          name: 'VOOY Ambulances',
          url: '/deleted-users/ambulance-list',
          icon: 'nav-icon fa fa-ambulance'
        },
        {
          name: 'VOOY Users',
          url: '/deleted-users/vooy-users',
          icon: 'nav-icon fa fa-university'
        },
        {
          name: 'VOOYDriverPartner',
          url: '/deleted-users/vooy-partners',
          icon: 'nav-icon fa fa-money'
        },

        {
          name: 'VOOYRestaurants',
          url: '/deleted-users/seller-list',
          icon: 'nav-icon fa fa-cutlery'
        },
      ]
    },
    {
      name: 'Transaction',
      url: '/transaction',
      icon: 'nav-icon fa fa-credit-card-alt',
      children: [
        {
          name: 'Withdraw-Requests',
          url: '/transaction/withdraw-request',
          icon: 'nav-icon fa fa-money'
        },
        {
          name: 'DriverWallets',
          url: '/transaction/driver-wallet',
          icon: 'nav-icon fa fa-money'
        },
        {
          name: 'Health-Transactions',
          url: '/transaction/health-transaction',
          icon: 'nav-icon fa fa-money'
        }
      ]
    },
    {
      name: 'Order List',
      url: '/order',
      icon: 'nav-icon fa fa-first-order',
      children: [
        {
          name: 'Medical Appointment List',
          url: '/order/medical-appointments',
          icon: 'nav-icon fa fa-user-md'
        },
        {
          name: 'Nursing Appointment List',
          url: '/order/nurse-medical-appointments',
          icon: 'nav-icon fa fa-h-square'
        },
        {
          name: 'Shuttle Services',
          url: '/order/ambulance-medical-appointments',
          icon: 'nav-icon fa fa-space-shuttle'
        },
        {
          name: 'Shipment-List',
          url: '/order/shipment-list',
          icon: 'nav-icon fa fa-ship'
        },
        {
          name: 'Ride-List',
          url: '/order/ride-list',
          icon: 'nav-icon fa fa-motorcycle'
        },
        {
          name: 'Destination-List',
          url: '/order/destination-list',
          icon: 'nav-icon fa fa-car'
        },
        {
          name: 'Order Group List',
          url: '/order/order-group',
          icon: 'nav-icon fa fa-first-order'
        },
        {
          name: 'Food Order List',
          url: '/order/food-orders',
          icon: 'nav-icon fa fa-coffee'
        },
        {
          name: 'FarmaList',
          url: '/order/farma-list',
          icon: 'nav-icon fa fa-plus-circle'
        },
      ]
    },
    {
      name: 'Help Section',
      url: '/transaction',
      icon: 'nav-icon fa fa-credit-card-alt',
      children: [
        {
          name: 'Partner Help Section',
          url: '/help/partner-help',
          icon: 'nav-icon fa fa-money'
        },
        {
          name: 'User Help Section',
          url: '/help/user-help',
          icon: 'nav-icon fa fa-money'
        },
        {
          name: 'Seller Help Section',
          url: '/help/seller-help',
          icon: 'nav-icon fa fa-money'
        }
      ]
    },
    {
      name: 'AppointmentSchedule',
      url: '/partner-appointment',
      icon: 'nav-icon fa fa-ticket'
    },
    {
      name: 'Reporting Center',
      url: '/report',
      icon: 'nav-icon fa fa-first-order',
      children: [
        {
          name: 'User Reports Partner',
          url: '/report/user-reports',
          icon: 'nav-icon fa fa-first-order'
        },
        {
          name: 'Partner Reports User',
          url: '/report/partner-reports',
          icon: 'nav-icon fa  fa-first-order'
        },
        {
          name: 'Application Logs',
          url: '/report/application-logs',
          icon: 'nav-icon fa fa-exclamation-triangle'
        },
      ]
    },
    {
      name: "Scheduled Services",
      url: "/order/scheduled-orders",
      icon: "nav-icon fa fa-ticket",
    },
    // {
    //   name: (languageCode === LanguageCodeEnum.US_English) ? 'VOOY HEALTH' : 'VOOY SALUD',
    //   url : ''
    // },
    // {
    //   name: (languageCode === LanguageCodeEnum.US_English) ? 'Dashboard' : 'Tablero',
    //   url: '/',
    //   icon: 'nav-icon fa fa-dashboard',
    //   children: [
    //     {
    //       name: (languageCode === LanguageCodeEnum.US_English) ? 'Requests' : 'Solicitudes',
    //       url: '/health/request-dashboard',
    //       icon: 'nav-icon fa fa-first-order'
    //     },
    //     {
    //       name: (languageCode === LanguageCodeEnum.US_English) ? 'Doctor' : 'Médico' ,
    //       url: '/health/doctor-statistics',
    //       icon: 'nav-icon fa fa-user-circle-o'
    //     },
    //   ]
    // },
    // {
    //   name: (languageCode === LanguageCodeEnum.US_English) ? 'VOOY HEALTH' : 'VOOY SALUD',
    //   url: '/health',
    //   icon: 'nav-icon fa fa-stack-overflow',
    //   children: [
    //     // {
    //     //   name: (languageCode === LanguageCodeEnum.US_English) ? 'VOOY Doctors' : 'VOOY Médicos',
    //     //   url: '/health/doctor-list',
    //     //   icon: 'nav-icon fa fa-medkit'
    //     // },
    //     {
    //       name: (languageCode === LanguageCodeEnum.US_English) ? 'Nurses' : 'Enfermeros',
    //       url: '/health/nurses-list',
    //       icon: 'nav-icon fa fa-user-md'
    //     },
    //     {
    //       name: (languageCode === LanguageCodeEnum.US_English) ? 'Ambulances' : 'Ambulancias',
    //       url: '/health/ambulance-list',
    //       icon: 'nav-icon fa fa-ambulance'
    //     },

    //   ]
    // },
  ];
  return navItems;
}
